import { create } from 'zustand';

export interface NavigationHistoryEntry {
  page: string;
  params: Record<string, string>;
}

interface NavigationState {
  page: string;
  params: Record<string, string>;
  history: NavigationHistoryEntry[];
  cartDrawerOpen: boolean;
  navigate: (page: string, params?: Record<string, string>) => void;
  goBack: () => void;
  setCartDrawerOpen: (open: boolean) => void;
}

const MAX_HISTORY = 50;

export const useNavigationStore = create<NavigationState>((set, get) => ({
  page: 'home',
  params: {},
  history: [],
  cartDrawerOpen: false,

  navigate: (page: string, params: Record<string, string> = {}) => {
    // Intercept 'cart' navigation to open drawer instead
    if (page === 'cart') {
      set({ cartDrawerOpen: true })
      return
    }

    set((state) => {
      const currentEntry: NavigationHistoryEntry = {
        page: state.page,
        params: state.params,
      };

      const newHistory =
        state.page === 'home' && Object.keys(state.params).length === 0
          ? [currentEntry]
          : [...state.history, currentEntry].slice(-MAX_HISTORY);

      return {
        page,
        params,
        history: newHistory,
      };
    });
  },

  goBack: () => {
    set((state) => {
      if (state.history.length === 0) {
        return { page: 'home', params: {} };
      }

      const previous = state.history[state.history.length - 1];
      const newHistory = state.history.slice(0, -1);

      return {
        page: previous.page,
        params: previous.params,
        history: newHistory,
      };
    });
  },

  setCartDrawerOpen: (open: boolean) => {
    set({ cartDrawerOpen: open })
  },
}));
